import UniversalRouter from 'universal-router'
import * as pathToRegexp from 'path-to-regexp'
import typeChecker from './typeChecker'

const routes = require(`${process.env.PROJECT_NAME}/routes`).default
const importedRoutePaths = []

function isRouteImported(importedRoutePaths, routeToBeImported) {
  return importedRoutePaths.some(importedRoutePath => {
    const codeSplitPath = routeToBeImported.codeSplitPath
    if (typeChecker.isArray(codeSplitPath)) {
      return (
        typeChecker.isArray(importedRoutePath) && JSON.stringify(importedRoutePath) === JSON.stringify(codeSplitPath)
      )
    }
    return !typeChecker.isArray(importedRoutePath) && importedRoutePath === codeSplitPath
  })
}

async function appendRoute(context) {
  const { route, pathname, path } = context
  const childPath = path ? pathname.split(path)[1] : pathname
  let routeToBeImported
  let routeOrderToBeImported
  const routeChildrenLength = route.children.length
  for (let i = 0; i < routeChildrenLength; i = i + 1) {
    const child = route.children[i]
    if (!(child.importRoute && child.codeSplitPath)) {
      continue
    }
    if (child.codeSplitPath && typeChecker.isArray(child.codeSplitPath)) {
      for (const z in child.codeSplitPath) {
        if (pathToRegexp(child.codeSplitPath[z]).exec(childPath)) {
          routeToBeImported = child
          routeOrderToBeImported = i
          break
        }
      }
    } else if (typeChecker.isString(child.codeSplitPath)) {
      if (pathToRegexp(child.codeSplitPath).exec(childPath)) {
        routeToBeImported = child
        routeOrderToBeImported = i
      }
    }
    if (routeToBeImported) {
      break
    }
  }
  if (!routeToBeImported || isRouteImported(importedRoutePaths, routeToBeImported)) {
    return
  }
  importedRoutePaths.push(routeToBeImported.codeSplitPath)
  route.children = [
    ...route.children.slice(0, routeOrderToBeImported),
    (await routeToBeImported.importRoute()).default,
    ...route.children.slice(routeOrderToBeImported),
  ]
}

export default new UniversalRouter(routes, {
  async resolveRoute(context, params) {
    if (typeof context.route.action === 'function') {
      const { route } = context
      if (route.children && route.children.some(child => child.importRoute)) {
        await appendRoute(context)
      }
      return route.action(context, params)
    }
    return undefined
  },
})
